import { Container, Modal } from "react-bootstrap";
import PrimaryButton, {
  SecondaryButton,
} from "../../../../util/Btns/PrimaryButton";

import Close from "../../../../Assets/close.svg";
import styles from "./styles.module.scss";
import { publishType } from "../../../../util/helpers/statusHelper";
import { useRepublishBuild } from "../../../../hooks/DevAppHooks";

const RollBack=({showModal,setShowModal,build})=>{
    const handleClose = () => setShowModal(false);
    const { mutate: republishBuildMutate } = useRepublishBuild();

    const handleSubmit=()=>{
        republishBuildMutate({releaseid:build.id,publishType:publishType.rollback});
    }
    return(
        <Container>
            <div className={styles.body}>
              <span className="font-size-16 text-white">Are you sure you want to roll back to selected version?</span>
              <p className="font-size-16 text-gray-44">If yes then the selected build will be published to the app store.</p>
            </div>
            <div className={styles.buttonContainer}>
                <SecondaryButton onClick={() => setShowModal(false)}>
                  No
                </SecondaryButton>
                <PrimaryButton
                  onClick={() => {
                    handleSubmit();
                    setShowModal(false);
                  }}
                >
                  Yes
                </PrimaryButton>
              </div>
      </Container>
    )

}



export default RollBack;